<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Версия</label>
            <crm-input-text
              [(value)]="changelog.version"
              placeholder="1.0.0"
              [disabled]="canDelete"
              [isError]="$any(errors?.version)"></crm-input-text>
            <small
              *ngIf="errors?.version"
              class="p-error">
              {{ errors.version | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Дата публикации</label>
            <crm-datepicker
              [(value)]="changelog.publicationDate"
              [inputStyleClass]="errors?.publicationDate ? 'ng-invalid ng-dirty' : ''"
              [showTime]="true"
              [stepMinute]="5"></crm-datepicker>
            <small
              *ngIf="errors?.publicationDate"
              class="p-error">
              {{ errors.publicationDate | join }}
            </small>
          </div>

          <div class="field">
            <div class="flex justify-content-between align-items-center">
              <label class="font-medium required-field">Описание</label>
              <crm-button
                label="+ Описание"
                styleClass="p-button-text"
                (onClick)="addBlock()"></crm-button>
            </div>

            <ng-container *ngFor="let block of changelog.descriptionBlocks; let i = index">
              <p-card class="mb-3">
                <div class="flex justify-content-between align-items-center mb-2">
                  <div class="font-medium">Блок {{ i + 1 }}</div>
                  <crm-button
                    *ngIf="(changelog.descriptionBlocks?.length || 0) > 1"
                    label="Удалить"
                    styleClass="p-button-danger p-button-text"
                    (onClick)="removeBlock(i)"></crm-button>
                </div>

                <div class="field">
                  <label class="font-medium required-field">Описание</label>
                  <crm-editor
                    [(value)]="block.description"
                    height="220px"></crm-editor>
                </div>

                <div class="field-checkbox">
                  <p-checkbox
                    [(ngModel)]="block.forAllTariffs"
                    [binary]="true"
                    inputId="forAllTariffs_{{i}}"
                    (onChange)="onToggleForAllTariffs(block)"></p-checkbox>
                  <label [for]="'forAllTariffs_' + i">Для всех тарифов</label>
                </div>

                <div
                  class="field"
                  *ngIf="!block.forAllTariffs">
                  <label class="font-medium required-field">Модули</label>
                  <crm-multi-select
                    [options]="modules"
                    [(selectedItems)]="block.modules"
                    optionValue="name"
                    display=""
                    placeholder="Выберите модули"
                    appendTo="body">
                    <ng-template
                      #selectedItemsTemplate
                      let-items="items">
                      <ng-container *ngFor="let item of items; last as isLast">
                        {{ getModuleDisplayName(item.value) }}{{ isLast ? '' : ', ' }}
                      </ng-container>
                    </ng-template>
                    <ng-template
                      #itemTemplate
                      let-option="item">
                      <div>
                        <p>{{ getModuleDisplayName(option.value) }}</p>
                        <small class="text-gray-400">{{ getModuleDescription(option.value) }}</small>
                      </div>
                    </ng-template>
                  </crm-multi-select>
                  <small class="text-gray-400">
                    Блок будет показан только тарифам, где включен выбранный модуль.
                  </small>
                </div>
              </p-card>
            </ng-container>
          </div>

          <div class="field">
            <label class="font-medium">Комментарий</label>
            <crm-editor
              [(value)]="changelog.shortSummary"
              height="110px"></crm-editor>
            <small
              *ngIf="errors?.shortSummary"
              class="p-error">
              {{ errors.shortSummary | join }}
            </small>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveChangelog()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteChangelog()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
